module.exports = __webpack_public_path__ + "media/img/pages/companies/noser-engineering-87f07e49b7b4fe4eda6b0d2399941454.png";